import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LayoutNew from "../components/shared/LayoutNew";
import DesktopShell from "../components/shared/DesktopShell";
import CasinoGamesSection from "../components/home/CasinoGamesSection";

// Desktop "Live Casino" nav entry opens this page: the shared three-column
// shell (header + left Sports sidebar + center casino cards + right Open Bets)
// with the casino tabs/cards grid in the center — matching the reference site.
// On mobile the existing mini-casino / casino route behaviour is unchanged, so
// this page is only reached on desktop.
const LiveCasinoPage = () => {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(
    () => window.matchMedia("(min-width: 1024px)").matches
  );
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  // On mobile this route isn't the casino surface — send users home where the
  // mini-casino launcher lives.
  useEffect(() => {
    if (!isDesktop) navigate("/");
  }, [isDesktop, navigate]);

  if (!isDesktop) return null;

  return (
    <LayoutNew desktopHome>
      <DesktopShell activeNav="Live Casino">
        <div id="liveCasinoWrap" className="mian-wrap">
          <CasinoGamesSection />
        </div>
      </DesktopShell>
    </LayoutNew>
  );
};

export default LiveCasinoPage;
